import * as React from "react";
import Stack from "@mui/material/Stack";
import MailIcon from '@mui/icons-material/Mail';
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import TelegramIcon from '@mui/icons-material/Telegram';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Footer } from "../components";
import Logo from "../components/Logo";
import { FaFacebook, FaDiscord } from 'react-icons/fa'
import { BsMedium } from 'react-icons/bs'
import useMediaQuery from "@mui/material/useMediaQuery";

const FooterComponent = () => {
  const ismobile = !useMediaQuery('(min-width:800px)');

  return (
    <Footer
      style={{
        width: ismobile ? '100%' : 1300,
        height: ismobile ? 'fit-content' : 130,
        padding: ismobile ? '40px 10px 80px 10px' : "20px 0",
      }}
    >
      <Stack
        width="100%"
        px={ismobile ? 0 : 8}
        alignItems='center'
        direction={ismobile ? 'column' : 'row'}
        justifyContent='space-between'
      >
        <Logo />
        <Stack
          direction='row'
          spacing={1}
          mt={ismobile ? 7 : 0}
          mb={ismobile ? 4 : 0}
          sx={{
            '& button': {
              color: '#FFFFFF80'
            }
          }}>
          <a href="https://t.me/sportsbook_2xlucky" target='_blank'>
            <IconButton aria-label="telegram">
              <TelegramIcon />
            </IconButton>
          </a>
          <a href="https://discord.gg/hTaetCbjum" target='_blank'>
            <IconButton aria-label="discord">
              <FaDiscord />
            </IconButton>
          </a>
          <a href="https://www.facebook.com/2xlucky/" target='_blank'>
            <IconButton aria-label="facebook">
              <FaFacebook fontSize={22} />
            </IconButton>
          </a>
          <a href="https://www.instagram.com/2xluckyonline/" target='_blank'>
            <IconButton aria-label="instagram">
              <InstagramIcon />
            </IconButton>
          </a>
          <a href="https://2xlucky.medium.com/" target='_blank'>
            <IconButton aria-label="medium">
              <BsMedium />
            </IconButton>
          </a>
          <a href="mailto:support@2xlucky.io" target='_blank'>
            <IconButton aria-label="mail">
              <MailIcon />
            </IconButton>
          </a>
          <a href="https://twitter.com/2xluckyonline" target='_blank'>
            <IconButton aria-label="twitter">
              <TwitterIcon />
            </IconButton>
          </a>
        </Stack>
        <Typography fontSize={18} fontWeight={700} color="#FFFFFF40">
          © 2022 - 2xlucky.io All Right Reserved
        </Typography>
      </Stack>
    </Footer>
  );
};

export default FooterComponent;
